/**
 * Entity yasam dongusu sistemi.
 *
 * Engine'in entity listesini ve kare-fazlarini (begin -> animate -> beforeRender)
 * sahiplenir. Engine yalnizca `entities` / `addEntity` / `removeEntity` yuzeyini
 * buraya delege eder.
 */
import { Entity, $engineKey } from "../Entity";
import { logger } from "../../util/Logger";
import type { Engine } from "../Engine";
import type { EngineSystem, FrameContext, FramePhase } from "../runtime/EngineSystem";

export class EntitySystem implements EngineSystem {
  readonly name = "entities";
  readonly labels: Partial<Record<FramePhase, string>> = {
    begin: "entities.begin",
    update: "entities.animate",
    beforeRender: "entities.beforeRender",
  };

  /** Aktif entity'ler (Engine.entities buraya delege eder). */
  entities: Entity[] = [];
  /** Henuz begin() cagrilmamis yeni eklenenler. */
  private _new: Entity[] = [];
  private _engine!: Engine;

  init(engine: Engine): void {
    this._engine = engine;
  }

  add = (entity: Entity): void => {
    try {
      this._new.push(entity);
      this.entities.push(entity);
      entity[$engineKey] = this._engine;
      entity.onAdd(this._engine);
    } catch (e) {
      logger.error("****Engine", "handled error:", e);
    }
  };

  remove = (entity: Entity): void => {
    try {
      this.entities = this.entities.filter((e) => entity != e);
      entity[$engineKey] = null;
      entity.onRemove(this._engine);
    } catch (e) {
      logger.error("****Engine", "handled error:", e);
    }
  };

  begin(): void {
    const list = this._new;
    if (list.length === 0) return;
    this._new = [];
    for (const e of list) e.begin();
  }

  update(ctx: FrameContext): void {
    const scene = ctx.engine.activeScene!;
    const camera = ctx.engine.activeCamera!;
    for (const e of this.entities) e.animate(ctx.dt, scene, camera);
  }

  beforeRender(): void {
    for (const e of this.entities) e.beforeRender();
  }
}
